module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "full-box"
  }, [_c('div', {
    staticClass: "loadingWorkOrders"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(0), _vm._v("\n      Loading Notes for Work Order #" + _vm._s(this.$route.params.id) + "        \n    ")])]) : _vm._e(), _vm._v(" "), (_vm.openMenu) ? [_c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "mobile-menu"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close-menu",
    on: {
      "click": function($event) {
        return _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.backToListings()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('br'), _c('br')])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('button', {
    staticClass: "pull-right btn header-btn mcBG scBGHover",
    on: {
      "click": function($event) {
        return _vm.goBackToWO()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Back to the Work Order")])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.goBackToWO()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.showMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-header-bar mcBG"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": "static/img/i3v_icon_white.png"
    }
  }), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('h1', [_vm._v("Notes "), _c('span', [_vm._v("[WO# " + _vm._s(_vm.workOrder) + "]")])])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', [_c('h1', [_vm._v("Notes - WO# " + _vm._s(_vm.workOrder) + " ")])]) : _vm._e()])])])])]), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet)) ? _c('div', {
    staticClass: "tablet-view"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flexrow"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("Internal Notes")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "woListing"
    }
  }, [_c('ul', _vm._l((_vm.notesRecords.slice().reverse()), function(note) {
    return _c('li', [_c('div', {
      staticClass: "container-fluid"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      attrs: {
        "clworkOrder.priorityass": "col-xs-12"
      }
    }, [_c('div', {
      staticClass: "woTopRow"
    }, [_c('strong', [_vm._v(_vm._s(note.sender))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(note.messageTimeStamp, "MMM Do, YYYY HH:MM")) + ":")]), _vm._v(" " + _vm._s(note.Note))])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "inner"
  }, [(!_vm.workOrderCheck.fieldComplete) ? _c('div', [_c('h2', [_vm._v("Send a Note:")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usersNote),
      expression: "usersNote"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.usersNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usersNote = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn mcBG scBGHover",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Reply")])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "inner-dark"
  }, [_c('h3', {
    staticClass: "mcText"
  }, [_c('span', [_vm._v("Username")]), _vm._v("\n            " + _vm._s(_vm.username))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.refreshListing()
      }
    }
  }, [_vm._v("My Work Orders "), _c('i', {
    staticClass: "fa fa-list-ul",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log Out "), _c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('br'), _c('br')])])])])]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet - 1)) ? _c('div', [_c('div', {
    staticClass: "mobile-view"
  }, [_c('div', {
    attrs: {
      "id": "woListing"
    }
  }, [_c('ul', _vm._l((_vm.notesRecords.slice().reverse()), function(note) {
    return _c('li', [_c('div', {
      staticClass: "container-fluid"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "woTopRow"
    }, [_vm._v("\n                    " + _vm._s(note.sender) + "\n                  ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(note.messageTimeStamp, "MMM Do, YYYY HH:MM")) + ":")]), _vm._v(" " + _vm._s(note.Note))])])])])])
  }), 0)]), _vm._v(" "), (!_vm.workOrderCheck.fieldComplete) ? _c('div', [_c('div', [_c('div', {
    staticClass: "mobileBottomBar"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usersNote),
      expression: "usersNote"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.usersNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.usersNote = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn mcBG scBGHover",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Reply")])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v("    " + _vm._s(_vm.$data) + "\n  ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-image"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56f9f642!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notes.vue
// module id = 857
// module chunks = 2